export default "<p>accountantdashboard works!</p>\n"